export const faqs = [
  {
    q: "「灵灵黑料」目前有哪些是已经被证实的？",
    a: "截至目前，可核验的信息主要是当事人公开发布的回应内容、工作室声明的存在，以及平台对相关内容的处理结果。除此之外的具体指控、私人聊天记录与匿名爆料，多数仍处于「待确认」状态，本站会随时间线更新标注。",
  },
  {
    q: "灵灵本人一共回应了几次？",
    a: "公开可查的回应包含一次正式文字回应与一次补充说明，两者在语气和重点上有所不同。第一次侧重否认整体传言，第二次则对部分细节作了补充解释，但仍有若干具体问题没有直接回答。",
  },
  {
    q: "网上流传的聊天记录可信吗？",
    a: "判断聊天记录是否可信，至少要看三点：是否有原始设备来源、时间戳是否与公开行程矛盾、头像与昵称是否只在单张截图里出现。目前流传最广的几组截图缺少来源说明，本站将其归类为「待确认」。",
  },
  {
    q: "为什么同一件事，粉丝和路人的看法差这么多？",
    a: "主要来自三处差异：信息源不同（内部信息 vs 公开信息）、判断标准不同（相信当事人 vs 要求证据）、情绪立场不同。理解这三层差异，比争论谁更有道理更能解释分歧。",
  },
  {
    q: "「已交由律师处理」这类声明到底意味着什么？",
    a: "它通常表示立场已经转向法律途径，但不等于对方已被认定违法，也不代表事件结束。判断实际影响，要看后续是否出现正式的立案、起诉或平台处置等可核验动作。",
  },
  {
    q: "本站的内容立场是什么？",
    a: "本站不替任何一方站台，也不发布未核实的爆料。我们只做三件事：整理公开说法、标注信息可信等级、提供判断信息的方法。所有结论都保留「以当事人与官方最新公告为准」的前提。",
  },
];